/* eslint-disable no-debugger */
// import { HttpClientNormal } from "@/fetchInterceptor/HttpClient";
import { IRcResourceService } from "./IRcResourceService";
import { ResourceAllowOrderForm } from "@/common/enums";
import { ResourceInfo } from "../resource-service";
import { IOutlookAppointmentService, TokenIOutlookAppointmentService } from "@/out-look/services";
import { baContainer } from "@/ioc";
import { HttpResponse, SearchResponse } from "@/fetchInterceptor/AxiosMethod";
import { AxiosResponse } from "axios";

import { config } from "@/config";
import { HttpClientNormal } from "@/fetchInterceptor/HttpClient";
import { CreateExternalTempReservationResponse, ExternalBookingResponse, CheckExternalResourcesResponse } from "./entity/response";
import { OrderDataRequest } from "./entity/OrderDataRequest";

export class RcResourceService implements IRcResourceService {
  private http: HttpClientNormal = new HttpClientNormal();
  private readonly _olAppointmentService: IOutlookAppointmentService;

  constructor() {
    this._olAppointmentService = baContainer.resolve(TokenIOutlookAppointmentService);
    // this._olOrganizerService = baContainer.resolve(TokenIOrganizationService);
  }

  getStatusAllowOrderForm(resource: ResourceInfo, originalSelectedResources: ResourceInfo[]): ResourceAllowOrderForm {
    // recurring
    const apt = this._olAppointmentService.GetCurrentAppointment();
    if (apt && apt.IsRecurringMaster && originalSelectedResources.filter((t: any) => t.Id == resource.guid).length > 0 && (apt.HaveNormalOrder || apt.IsReopenAfterSent)) {
      return ResourceAllowOrderForm.IsRecurring;
    }

    // light resource
    if (resource?.isLightResource) {
      return ResourceAllowOrderForm.LightResource;
    }
    // tentative resource

    //caculate childVR
    // if (this._isChildVR(resource.Id)) {
    //   return ResourceAllowOrderForm.ChildVR;
    // }

    // //caculate different SOF
    // if (this._isDifferentSOF()) {
    //   return ResourceAllowOrderForm.DifferentSOF;
    // }

    if (resource.isWorkspace) {
      return ResourceAllowOrderForm.Workspace;
    }

    return ResourceAllowOrderForm.Allow;
  }

  fetchExternalBookingResources = (payload: OrderDataRequest): Promise<SearchResponse<ExternalBookingResponse>> => {
    const _url: string = `${config.API_URL}/ResourceCentral/PostGateway?action=GetExternalBookingResources`;
    return this.http
      .post(_url, payload)
      .then((resp: AxiosResponse) => {
        const { Data, Status, Message } = resp.data;
        console.log("🚀 ~ RcResourceService ~ fetchExternalBookingResources ~ resp:", resp.data)
        return new SearchResponse<ExternalBookingResponse>({
          data: Data,
          status: Status ? 200 : 400,
          statusText: Message,
          headers: {} as any,
          config: {} as any,
        }, undefined, true);
      })
      .catch((err) => new SearchResponse(err?.response));
  };

  fetchCreateExternalTempReservation = (request: OrderDataRequest): Promise<HttpResponse<CreateExternalTempReservationResponse>> => {
    const _url: string = `${config.API_URL}/ResourceCentral/PostGateway?action=CreateExtenalTempReservationForMovingOrder`;
    return this.http
      .post(_url, request)
      .then((resp: AxiosResponse<{ Data: CreateExternalTempReservationResponse; Status: boolean; Message: string }>) => {
        const { Data, Status, Message } = resp.data;
        return new HttpResponse<CreateExternalTempReservationResponse>({
          data: Data,
          status: Status ? 200 : 400,
          statusText: Message,
          headers: {} as any,
          config: {} as any,
        });
      })
      .catch((err) => new HttpResponse(err?.response));
  };

  fetchCheckExternalResourcesSuitableForMovingOrder = (request: OrderDataRequest): Promise<HttpResponse<CheckExternalResourcesResponse>> => {
    const _url: string = `${config.API_URL}/ResourceCentral/PostGateway?action=CheckExtenalResourcesSuitableForMovingOrder`;
    return this.http
      .post(_url, request)
      .then((resp: AxiosResponse) => {
        const { Data, Status, Message } = resp.data;
        console.log("🚀 ~ RcResourceService ~ fetchCheckExternalResourcesSuitableForMovingOrder ~ resp:", resp.data)
        const rs = new HttpResponse<CheckExternalResourcesResponse>({
          data: Data,
          status: Status ? 200 : 400,
          statusText: Message,
          headers: {} as any,
          config: {} as any,
        });
        debugger;
        return rs;
      })
      .catch((err) => new HttpResponse(err?.response));
  };

  fetchCheckResource = (request: OrderDataRequest): Promise<HttpResponse<any>> => {
    const _url: string = `${config.API_URL}/ResourceCentral/PostGateway?action=CheckResource`;
    return this.http
      .post(_url, request)
      .then((resp: AxiosResponse) => new HttpResponse(resp.data));
  };
}
